import { styled } from 'styled-components';

import { colors, fontWeights, transition } from '#/theme/theme';

const labelBackgroundVar = '--icon-select-buttons-label-background';
const labelColorVar = '--icon-select-buttons-label-color';

export const IconSelectHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 8px;
`;

export const IconSelectLabel = styled.label<{
  $selected: boolean;
}>`
  ${labelBackgroundVar}: ${colors.inputGrey};
  ${labelColorVar}: ${colors.lightContentGrey};

  width: 110px;
  height: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: var(${labelBackgroundVar});
  color: var(${labelColorVar});
  padding: 16px 12px;
  border-radius: 8px;
  transition: ${transition};
  user-select: none;

  ${({ $selected }) =>
    $selected &&
    `
      ${labelBackgroundVar}: ${colors.softBlue};
      ${labelColorVar}: ${colors.hoverBlue};
    `}

  cursor: pointer;

  &:hover {
    ${labelBackgroundVar}: ${colors.selectionGrey};
  }
`;

export const IconSelectTextHolder = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  font-weight: ${fontWeights.semiBold};
  font-size: 14px;
  text-align: center;
`;
